import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage/HomePage';
import DetailsPage from './pages/Detailspage/Detailspage'; // Updated import path
import axios from 'axios';
import Mybicycle from "./pages/Mybicycle";
import EditDetailspage from './pages/EditDetailspage/EditDetailspage';


function App() {
  const [bicycleData, setBicycleData] = useState(null);

  useEffect(() => {
    // Fetch the bicycle data from your API
    axios.get('https://bicycle-shop-yrw52crgba-de.a.run.app/product/getBicycleByValues')
      .then((response) => {
        console.log('Fetched data:', response.data);
        setBicycleData(response.data);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/your-bicycle/:year/:make/:model/:trim"
          element={<DetailsPage />} // Pass the fetched data as a prop
        />
        <Route path="/mybicycle" element={<Mybicycle />} />
        <Route path="/edit-details/:year/:make/:model/:trim/:id" element={<EditDetailspage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
